import ModuleManager from '../../../../framework/core/module_manager';
import NetPrompt from '../../../public/module/netprompt/netprompt';
import ServerBase from '../server_base';
import { Notify } from './proto_notify';
import { NetMsgDataMapNotify } from './net_msg_data_map_notify';
import EventManager from '../../../../manager/event_manager';
import { NetClientProtoType } from '../../../../framework/net/net_client';
import UserDataManager from '../../../../manager/user_manager';
import Utility from '../../../../utility/utility';
import LogManager from '../../../../manager/log_manager';
import { chat_data } from '../../module/chat/chat_data';
import ModelData from '../../../public/model_data';
import AppData from '../../../public/const/app_data';



const { ccclass } = cc._decorator;


@ccclass
export default class NotifyServer extends ServerBase {


    public static instance: NotifyServer;
    private isLogin = false;
    registTagCallBack: () => void;

    private _registGameTags

    onLoad() {
        NotifyServer.instance = this
        this.netClientProtoType = NetClientProtoType.EventNotify
        this.init("NotifyServer")
        this._maxReconTimes = 10000


    }

    connectServer(url) {
        this.connect(url);
    }

    protected onConnected() {
        this.loginServer();
        if (this.registTagCallBack) {
            this.registTagCallBack();
        }

        EventManager.instance.dispatch("Event_Notify_Connected",this.isReconnect);
    }

    loginServer() {
        let self = this
        self.model.subscibeMsgEvent<Notify.RSP_CommonMessage>(NetMsgDataMapNotify.CommonMessage, function (protoData) {
            self.lastReceivePingTime = Date.now()

            //console.log(" RSP_CommonMessage " , protoData.type);

            if (protoData.type == 1) {//注册推送标签 注册相关标签就能收到改推送通知
                EventManager.instance.dispatch("Event_Notify_Tag_Success")
                self.startCheckPing()
            } else if (protoData.type == 2) {//推送通知
                if (protoData.code == 'ok') {
                    let notifyData = Notify.NotifyMessage.decode(protoData.data)
                    if (notifyData.content) {
                        EventManager.instance.dispatch("Event_Notify_Data", notifyData)
                        //let str = JSON.parse(notifyData.content).content
                        //chat_data.saveSystemData(str)
                    }
                    if (notifyData.notifyType == "club_hall_change") {
                        EventManager.instance.dispatch("Event_Notify_Club_Hall_Change")
                    }
                    if (notifyData.notifyType == "club_notice_change") {
                        EventManager.instance.dispatch("Event_Notify_Club_Notify_Change",notifyData.content)
                    }
                }
             
            } else if (protoData.type == 3) {//更新玩家位置
                CC_JSB && LogManager.instance.log(`【${self.netClient.name}】收包: ${protoData.type}  ${JSON.stringify(Notify.ChangePlayerPosition.decode(protoData.data))}`)
            } else if (protoData.type == 4) {//账户余额变动
                if (protoData.code == 'ok') {
                    let notifyData = Notify.BalanceMessage.decode(protoData.data)
                    let balance = Number(notifyData.balance);
                    Utility.reportEffect(`game_recharge_sucess`)
                    if(notifyData.eventType == 155){ //俱乐部转账通知的是这次转账的值
                        UserDataManager.balanceChangeMessage(balance, notifyData.balanceType, true);
                        EventManager.instance.dispatch("Event_Notify_Club_Transfer",true)
                    } else {
                        UserDataManager.balanceChangeMessage(balance, notifyData.balanceType);
                    }
                }
                CC_JSB && LogManager.instance.log(`【${self.netClient.name}】收包: ${protoData.type}  ${JSON.stringify(Notify.ChangePlayerPosition.decode(protoData.data))}`)
            } else if (protoData.type == 5) {//App扩展信息推送
                let notifyData = Notify.AppNotifyMessage.decode(protoData.data)
                if (notifyData.notifyType == 'open_client_log') {
                    LogManager.instance.needUploadLogFile(notifyData.content)
                    CC_JSB && LogManager.instance.log(`【${self.netClient.name}】收包: ${protoData.type}  ${JSON.stringify(notifyData)}`)
                }else if (notifyData.notifyType == 'user_level_up') {
                    EventManager.instance.dispatch('Event_Notify_UserDetail',{type:'user_level_up',content:notifyData.content})
                }else if (notifyData.notifyType == 'user_exp_detail') {
                    EventManager.instance.dispatch('Event_Notify_UserDetail',{type:'user_exp_detail',content:notifyData.content})
                }else if(notifyData.notifyType == 'new_invite_msg'){
                    EventManager.instance.dispatch("Event_New_Invite_Msg");
                }
            }
            else if (protoData.type == 100) {
                let chatMsg = Notify.ChatMessage.decode(protoData.data)
                let chatActive = ModuleManager.instance.moduleHasActive("Chat")
                if (chatActive) {
                    EventManager.instance.dispatch("Event_Notify_Customer_Chat_Data", chatMsg)
                }else{
                    chat_data.saveFriendData(chatMsg)
                }
                
            }
            else if (protoData.type == 101) {//进入聊天群组
                console.log(" join group chat message success !");
            }
            else if (protoData.type == 102) { //聊天接收
                let chatMsg = Notify.GroupChatMessage.decode(protoData.data)           
                if (chatMsg.contentList && chatMsg.contentList.length > 0) {
                    EventManager.instance.dispatch("Event_Notify_Group_Chat_Data", chatMsg)
                }                                            
            }
        }, true);

    }

    /**
     * 注册全局标签
     * @param dynamicTag 动态标签
     */
    public registGameTag(dynamicTag? : string) {
        if (this._registGameTags == null) {
            this._registGameTags = []
            for (const key in AppData.gameNameToTableModule) {
                this._registGameTags.push("TM_" + key)
            }
        }
        let static_tags : string[] = [ModelData.instance.roleData.id.toString(),AppData.apiLanguage];

        let tags = static_tags.concat(this._registGameTags);

        if (dynamicTag) {
            tags = tags.concat(dynamicTag);   
        }

        this.requestCommand(tags);
    }

    //请求命令
    private requestCommand(tag: string[]) {
        let req = new Notify.RegPushTag()
        req.tag = tag
        let dataBuffer: Uint8Array = Notify.RegPushTag.encode(req).finish();
        var requestBuffer = new ArrayBuffer(8 + dataBuffer.length);
        let uint8Array = new Uint8Array(requestBuffer, 8, dataBuffer.length)
        uint8Array.set(dataBuffer);
        let requestData: Notify.ICMD_CommonMessage = {
            type: 1,
            token: "",
            data: dataBuffer
        }
        this.model.sendMsg(NetMsgDataMapNotify.CommonMessage, requestData)
    }
    protected _requestPing() {
        if (this.netClient.netState) {
            let requestData: Notify.ICMD_CommonMessage = {
                type: 0,
                token: ""
            }
            this.model.sendMsg(NetMsgDataMapNotify.CommonMessage, requestData)
        }
    }

    sendPlayerPosition(position: Notify.IChangePlayerPosition) {
        if (this.netClient.netState) {
            let dataBuffer: Uint8Array = Notify.ChangePlayerPosition.encode(position).finish();
            var requestBuffer = new ArrayBuffer(8 + dataBuffer.length);
            let uint8Array = new Uint8Array(requestBuffer, 8, dataBuffer.length)
            uint8Array.set(dataBuffer);
            let messageData: Notify.ICMD_CommonMessage = {
                type: 3,
                token: "",
                data: dataBuffer
            }
            this.model.sendMsg(NetMsgDataMapNotify.CommonMessage, messageData)
            CC_JSB && LogManager.instance.log(`【${this.netClient.name} 发包: sendPlayerPosition  ${JSON.stringify(position)}`)
        }
    }
    sendPlayerChatMessage(msg: Notify.IChatMessage) {
        if (this.netClient.netState) {
            let dataBuffer: Uint8Array = Notify.ChatMessage.encode(msg).finish();
            var requestBuffer = new ArrayBuffer(8 + dataBuffer.length);
            let uint8Array = new Uint8Array(requestBuffer, 8, dataBuffer.length)
            uint8Array.set(dataBuffer);
            let messageData: Notify.ICMD_CommonMessage = {
                type: 100,
                token: "",
                data: dataBuffer
            }
            this.model.sendMsg(NetMsgDataMapNotify.CommonMessage, messageData)
        }
    }    
    sendActionGroupChatMessage(msg: Notify.IActionGroupChatMessage) {
        if (this.netClient.netState) {
            let dataBuffer: Uint8Array = Notify.ActionGroupChatMessage.encode(msg).finish();
            var requestBuffer = new ArrayBuffer(8 + dataBuffer.length);
            let uint8Array = new Uint8Array(requestBuffer, 8, dataBuffer.length)
            uint8Array.set(dataBuffer);
            let messageData: Notify.ICMD_CommonMessage = {
                type: 101,
                token: "",
                data: dataBuffer
            }
            this.model.sendMsg(NetMsgDataMapNotify.CommonMessage, messageData)
        }
    }
    sendGroupChatMessage(msg: Notify.IGroupChatMessage) {
        if (this.netClient.netState) {
            let dataBuffer: Uint8Array = Notify.GroupChatMessage.encode(msg).finish();
            var requestBuffer = new ArrayBuffer(8 + dataBuffer.length);
            let uint8Array = new Uint8Array(requestBuffer, 8, dataBuffer.length)
            uint8Array.set(dataBuffer);
            let messageData: Notify.ICMD_CommonMessage = {
                type: 102,
                token: "",
                data: dataBuffer
            }
            cc.log(messageData.data)
            this.model.sendMsg(NetMsgDataMapNotify.CommonMessage, messageData)
        }
    }
    protected onReconnectServer() {
        ModuleManager.instance.showModule(NetPrompt, { "showImmediately": true, "reconnect": true })
    }

    exit() {

    }

}
